import MrtApi from './mrt-api';
import axios from 'axios';
import MrtNotifications from './mrt-notifications';

export class MrtRegApi extends MrtApi {
    static deselectEventPackage(evtId) {
        let url = MrtApi.createUrlForRoute('account.eventRegister.event-deselect');
        const notifications = new MrtNotifications();

        if (!confirm(Mrt.translations['Oled kindel, et soovid mitte osaleda?'])) {
            return;
        }

        axios.post(url, {evtId: evtId})
            .then(() => {
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                notifications.error(this.$t('Midagi läks valesti'));
            });
    }
}
